export const LOGIN_TYPES = {
  WELCOME: 'welcome',
  APP_CRASH: 'APP_CRASH',
  ERROR: 'error',
  ERROR_EMAIL: 'errorEmail',
} as const;

export type LoginType = (typeof LOGIN_TYPES)[keyof typeof LOGIN_TYPES];
